import { render, staticRenderFns } from "./RegistrationYearConfirmationModal.vue?vue&type=template&id=463a441e"
import script from "./RegistrationYearConfirmationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationYearConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports